import { type App } from 'vue';
import { registerPartials } from '@precon-tools-suite-by-shared/vue-partials';

// Export the
export { default as routes } from './routes';

// Export the composables that you want to use outside of this library.
export * from './composables/useRiskValues';

export {
    default as RiskValueBadge,
    type RiskValueBadgeInput,
} from './components/RiskValueBadge.vue';
export { default as RiskValueField } from './components/RiskValueField.vue';
export { default as RiskValuesTooltip } from './components/RiskValuesTooltip.vue';

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartials(
            app,
            {
                CreateProductCategory: () =>
                    import('./partials/CreateProductCategory.vue'),
                UpdateProductCategory: () =>
                    import('./partials/UpdateProductCategory.vue'),
                CreateThreatCategory: () =>
                    import('./partials/CreateThreatCategory.vue'),
                UpdateThreatCategory: () =>
                    import('./partials/UpdateThreatCategory.vue'),
                CreateThreat: () => import('./partials/CreateThreat.vue'),
                UpdateThreat: () => import('./partials/UpdateThreat.vue'),
                CreateRisk: () => import('./partials/CreateRisk.vue'),
                UpdateRisk: () => import('./partials/UpdateRisk.vue'),
                RiskDefinition: () => import('./partials/RiskDefinition.vue'),
                RiskSeverity: () => import('./partials/RiskSeverity.vue'),
                CreateQuestionPredicate: () =>
                    import('./partials/CreateQuestionPredicate.vue'),
                ReadOnlyComments: () =>
                    import('./partials/ReadOnlyComments.vue'),
                RiskColumns: () => import('./partials/RiskColumns.vue'),
                AddRiskColumn: () => import('./partials/AddRiskColumn.vue'),
                TeamsRiskColumns: () =>
                    import('./partials/TeamsRiskColumns.vue'),
                CreateRiskColumn: () =>
                    import('./partials/CreateRiskColumn.vue'),
                UpdateRiskColumn: () =>
                    import('./partials/UpdateRiskColumn.vue'),
            },
            '@precon-tools-suite-by-shared/gino-risk-database-feature/partials/'
        );
    },
};
